// This file was automatically generated from print.schedule.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.schedule');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.schedule.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageBreak pageWrap">');
  el8.template.print.header(opt_data, output);
  output.append('<h1 class="documentTitle">', (soy.$$escapeHtml(opt_data.requestedDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.requestedDate)) : ''), ' ', soy.$$escapeHtml(opt_data.physicianName), '\'s Schedule</h1><table class="schedule">');
  var slotList17337 = opt_data.slots;
  var slotListLen17337 = slotList17337.length;
  for (var slotIndex17337 = 0; slotIndex17337 < slotListLen17337; slotIndex17337++) {
    var slotData17337 = slotList17337[slotIndex17337];
    var bList17338 = slotData17337.begin;
    var bListLen17338 = bList17338.length;
    if (bListLen17338 > 0) {
      for (var bIndex17338 = 0; bIndex17338 < bListLen17338; bIndex17338++) {
        var bData17338 = bList17338[bIndex17338];
        output.append('<tr class="scheduleAppt"><td class="date">', (bIndex17338 == 0) ? soy.$$escapeHtml(slotData17337.timeStr) : '', '</td>');
        el8.template.print.schedule.appointment(soy.$$augmentData(bData17338, {numApptsInSlot: slotData17337.begin.length}), output);
        output.append('</tr>');
      }
    } else {
      output.append('<tr class="scheduleAppt"><td class="date">', soy.$$escapeHtml(slotData17337.timeStr), '</td><td class="scheduleName"></td><td class="scheduleReason"></td><td class="scheduleContact"></td></tr>');
    }
  }
  output.append('</table></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.schedule.appointment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.appt.patientName) ? '<td class="scheduleName"><p class="preserve">(ends at ' + soy.$$escapeHtml(opt_data.appt.endTime) + ')  <span class="el8Bold">' + soy.$$escapeHtml(opt_data.appt.patientName) + '</span> (D.O.B.: ' + (soy.$$escapeHtml(opt_data.appt.patientDob)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.appt.patientDob)) : '') + ')</p></td><td class="scheduleReason"><p class="preserve">' + ((opt_data.appt.apptType) ? soy.$$escapeHtml(opt_data.appt.apptType.name) + ((opt_data.appt.description) ? ' - ' + soy.$$escapeHtml(opt_data.appt.description) : '') : (opt_data.appt.description) ? soy.$$escapeHtml(opt_data.appt.description) : '') + ((opt_data.appt.status == 'cancelled') ? ' CANCELLED' : (opt_data.appt.status == 'notSeen') ? ' NOT&nbsp;SEEN' : '') + '</p></td><td class="scheduleContact"><p class="preserve">' + soy.$$escapeHtml(opt_data.appt.patientPhone) + '</p></td>' : (opt_data.appt.isTimeBlock) ? '<td class="scheduleName"><p class="preserve">Event: ' + soy.$$escapeHtml(opt_data.appt.description) + '</p></td><td class="scheduleReason"></td><td class="scheduleContact"></td>' : '');
  if (!opt_sb) return output.toString();
};
